import mq from "./mediaQuery";
import { MediaQueryAllQueryable } from "./types";

export function hyphenate(camel: string) {
  return camel.replace(/[A-Z]/g, (m) => `-${ m.toLowerCase()}`);
}

const keyVal = (k: string, v: unknown): string => {
  const realKey = hyphenate(k);

  // px shorthand
  if (typeof v === "number") {
    // eslint-disable-next-line no-param-reassign
    v = `${v}px`;
  }
  if (v === true) {
    return realKey;
  }
  if (v === false) {
    return `not ${realKey}`;
  }
  return `(${realKey}: ${v})`;
};

const join = (conds: string[]): string => conds.join(" and ");

// Converts media query object to a css query
const toQuery = (obj: Partial<MediaQueryAllQueryable>): string => {
  const rules: string[] = [];
  Object.keys(mq.all).forEach((k) => {
    const v = obj[k as keyof MediaQueryAllQueryable];
    if (v != null) {
      rules.push(keyVal(k, v));
    }
  });
  return join(rules);
};

export default toQuery;
